module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/143-norway-a11adf901aa579118ce2e6dc9bcf0cf5.svg";